import { render, staticRenderFns } from "./SmallBanner.vue?vue&type=template&id=839c6f24&scoped=true&"
import script from "./SmallBanner.vue?vue&type=script&lang=js&"
export * from "./SmallBanner.vue?vue&type=script&lang=js&"
import style0 from "./SmallBanner.vue?vue&type=style&index=0&id=839c6f24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839c6f24",
  null
  
)

export default component.exports